<template>
  <AuthLayout>
    <template #form>
      <router-link to="/welcome" class="auth-brand">
        <img src="/assets/logo.png" alt="Logo Saineo" class="auth-brand__mark" />
        <span class="auth-brand__name">saineo</span>
      </router-link>

      <h1 class="auth-title">Bonjour,</h1>
      <p class="auth-subtitle">Identifiez-vous pour retrouver vos menus.</p>

      <form class="auth-form" @submit.prevent="login">
        <v-text-field
          clearable
          label="Email"
          placeholder="johndoe@gmail.com"
          type="email"
          v-model="email"
          variant="outlined"
          rounded="lg"
          hide-details="auto"
          class="auth-input"
        ></v-text-field>

        <v-text-field
          label="Mot de passe"
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          @click:append-inner="show1 = !show1"
          clearable
          v-model="password"
          variant="outlined"
          rounded="lg"
          hide-details="auto"
          class="auth-input"
        ></v-text-field>

        <v-btn
          rounded="lg"
          size="large"
          type="submit"
          variant="elevated"
          class="auth-btn"
        >
          Se connecter
        </v-btn>

        <div class="auth-footer">
          <span>Pas encore de compte ?</span>
          <router-link to="/register">Créer un compte</router-link>
        </div>
      </form>
    </template>
  </AuthLayout>

  <v-snackbar v-if="errorMessage" v-model="errorMessage" color="error" top right>
    {{ errorMessage }}
  </v-snackbar>
</template>
  <script>
  import { getAuth, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
  import AuthLayout from '@/components/PublicPages/AuthLayout.vue';

    export default {
      components: { AuthLayout },
      data: () => ({
        visible: false,
        email: "",
        password: "",
        errorMessage: "",
        show1: false,
        rules: {
        required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
        },
      }),
      computed: {
          isValidEmail() {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              return emailRegex.test(this.forgottenEmail);
          },
      },
      methods: {
        login() {
          signInWithEmailAndPassword(getAuth(), this.email, this.password)
            .then(() => {
                this.$router.push('/');
            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
                console.error(errorCode, errorMessage);
                switch (error.code){
                    case 'auth/user-disabled':
                        this.errorMessage = 'Utilisateur désactivé';
                        break;
                    case 'auth/user-not-found':
                        this.errorMessage = 'Utilisateur non trouvé';
                        break;
                    case 'auth/invalid-login-credentials':
                        this.errorMessage = 'Mot de passe ou adresse mail incorrect';
                        break;
                    default:
                        this.errorMessage = 'Une erreur est survenue';
                        break;
                }
            });
        },
        loginWithGoogle() {
          const provider = new GoogleAuthProvider();
            signInWithPopup(getAuth(), provider)
                .then(() => {
                  this.$router.push('/')
                }).catch((error) => {
                    console.error(error);
                });
        }
      }
    }
  </script>

<style scoped>
  .auth-brand {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
    color: inherit;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-bottom: 16px;
  }

  .auth-brand__mark {
    width: 34px;
    height: 34px;
    object-fit: contain;
    display: block;
  }

  .auth-title {
    margin: 0;
    font-size: clamp(2rem, 4vw, 2.8rem);
    font-weight: 600;
    letter-spacing: -0.03em;
    color: #1A1615;
    line-height: 120%;
  }


  .auth-subtitle {
    margin: 6px 0 24px;
    color: #3c3f46;
    line-height: 1.6;
  }

  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .auth-btn {
    background: #1A1615 !important;
    color: #ffffff !important;
    border-radius: 999px !important;
    padding: 14px 34px;
    box-shadow: none !important;
    text-transform: none;
    font-weight: 700;
    font-family: inherit;
    letter-spacing: 0;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  .auth-btn:hover {
    opacity: 0.85;
    transform: translateY(-2px);
  }

  .auth-footer {
    display: flex;
    gap: 6px;
    align-items: center;
    font-size: 0.95rem;
    color: #3c3f46;
  }

  .auth-footer a {
    color: #111111;
    font-weight: 600;
    text-decoration: none;
  }

  :deep(.auth-input .v-field) {
    border-radius: 16px;
  }
</style>  
